module.exports = __webpack_public_path__ + "img/popular-posts-1.a6d9cabb.png";